module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isOpen) ? _c('div', {
    staticClass: "sidenav-overlay",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['sidenav', {
      open: _vm.isOpen
    }]
  }, [_c('div', {
    staticClass: "header-container mt-1"
  }, [_c('div', {
    staticClass: "brand-info",
    class: _vm.isExclusive ? 'brand-info-exclusives' : ''
  }, [_c('div', {
    staticClass: "brand-icon d-flex align-items-center"
  }, [_c('div', {
    staticClass: "brand-logo"
  }, [(_vm.isExclusive) ? _c('img', {
    attrs: {
      "src": require("./assets/images/tssgif.gif"),
      "alt": "Logo"
    }
  }) : _c('img', {
    attrs: {
      "src": require("./assets/images/non-member-logo2.gif"),
      "alt": "Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "location-icon",
    class: !_vm.authStatus ? 'ml-4' : ''
  }, [_c('LocationChange', {
    attrs: {
      "isSideNav": true
    }
  })], 1), _vm._v(" "), (_vm.authStatus) ? _c('div', {
    staticClass: "user"
  }, [_c('h6', {
    staticClass: "user-name",
    on: {
      "click": _vm.redirectToMyAcc
    }
  }, [_vm._v(_vm._s(_vm.user.firstname) + " " + _vm._s(_vm.user.lastname) + " "), _c('img', {
    staticStyle: {
      "width": "20px"
    },
    style: (_vm.isExclusive ? 'filter: invert(100%) brightness(90%);' : 'filter: invert(60%) brightness(80%);'),
    attrs: {
      "src": require("./assets/images/right-arrow.svg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "member-link",
    attrs: {
      "to": "/membership"
    }
  }, [(_vm.isExclusive) ? _c('div', [_c('p', {
    staticClass: "user-exclusive-member"
  }, [_vm._v("YOU ARE A MEMBER")]), _vm._v(" "), _c('p', {
    staticClass: "exclusive-description"
  }, [_vm._v("Total Member Saving Till Now: "), _c('span', [_vm._v(" " + _vm._s(_vm.currencySymbol) + _vm._s(_vm.exclusiveDetails && _vm.exclusiveDetails.exclusive_savings || 0))])])]) : _c('div', [_c('p', {
    staticClass: "non-exclusive-member"
  }, [_vm._v("BECOME A MEMBER")]), _vm._v(" "), _c('p', {
    staticClass: "exclusive-description",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Get Lowest Prices on All Products & More")])])])], 1) : _c('div', {
    staticClass: "login-block",
    on: {
      "click": _vm.redirectToLogin
    }
  }, [_c('span', [_vm._v("Log in/Register")])])])]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "notify-user"
  }, [_c('span', [(_vm.authStatus) ? [(_vm.user && _vm.user.tss_points && _vm.user.tss_points > 100) ? [_vm._v("\n              Use Your "), _c('span', {
    staticClass: "tss-highlight"
  }, [_vm._v(_vm._s(parseInt(_vm.user.tss_points)) + " ")]), _vm._v("TSS Points On Your Next Order\n              "), _c('img', {
    staticClass: "ml-1",
    staticStyle: {
      "width": "13.8px",
      "height": "13.8px",
      "cursor": "pointer",
      "margin-top": "-1px"
    },
    attrs: {
      "src": "https://tss-static-images.gumlet.io/icons/tssHelpDetails.png",
      "alt": "More Info"
    },
    on: {
      "click": _vm.setTSSPointsData
    }
  })] : [_vm._v("\n              Earn 10% Cashback on Every App Order\n\n              "), (_vm.isDesktop) ? _c('span', {
    staticClass: "my-1"
  }, [_c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.thesouledstore",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "store-icon",
    attrs: {
      "src": require("./assets/images/google-play-store-new.png"),
      "alt": "More Info"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/in/app/the-souled-store/id1493897434",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "store-icon",
    attrs: {
      "src": require("./assets/images/appstore.png"),
      "alt": "More Info"
    }
  })])]) : _vm._e()]] : [_vm._v("\n            Earn 10% Cashback on Every App Order\n\n            "), (_vm.isDesktop) ? _c('span', {
    staticClass: "my-1"
  }, [_c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.thesouledstore",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "store-icon",
    attrs: {
      "src": require("./assets/images/google-play-store-new.png"),
      "alt": "More Info"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://apps.apple.com/in/app/the-souled-store/id1493897434",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "store-icon",
    attrs: {
      "src": require("./assets/images/appstore.png"),
      "alt": "More Info"
    }
  })])]) : _vm._e()]], 2)]), _vm._v(" "), (_vm.isHelp) ? _c('tssHelpDetails', {
    attrs: {
      "setPopup": _vm.helpDetails,
      "processData": _vm.processData,
      "isSidenavOpen": true
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "nav-menu-container"
  }, _vm._l((_vm.sideNavData), function(item, sideNavIndex) {
    return _c('div', {
      key: sideNavIndex,
      staticClass: "nav-menu-list mb-3 d-flex"
    }, [_c('div', {
      staticClass: "nav-menu-item",
      on: {
        "click": function($event) {
          _vm.selectNavMenu(item)
        }
      }
    }, [_c('span', {
      class: [_vm.activeNav === item.name.toLowerCase() ? 'activeCat' : '']
    }, [_vm._v(_vm._s(item.name.toUpperCase()))])])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "list-container"
  }, [(_vm.sideNavCategoryData && _vm.sideNavCategoryData.cat_list && _vm.sideNavCategoryData.cat_list.length && _vm.sideNavCategoryData.cat_list.length > 0) ? _c('div', _vm._l((_vm.sideNavCategoryData.cat_list), function(item, catListIndex) {
    return _c('div', {
      key: catListIndex,
      staticClass: "item-list category-dropdown pb-2"
    }, [(item.is_crousel) ? _c('div', {
      staticClass: "list-crousel mt-2"
    }, [(item.category && item.category.length && item.category.length > 0) ? _c('div', {
      staticClass: "list-crousel-item"
    }, [_c('carousel', {
      key: _vm.activeNav,
      ref: "my-carousel",
      refInFor: true,
      class: _vm.isDesktop ? 'bannerview' : 'mobileBannerView',
      attrs: {
        "navigationEnabled": false,
        "paginationEnabled": true,
        "navigationNextLabel": " ",
        "navigationPrevLabel": " ",
        "autoplay": false,
        "loop": true,
        "speed": 500,
        "perPage": _vm.isDesktop ? 5 : 3.6,
        "scrollPerPage": true,
        "perPageCustom": [
          [292, 3],
          [350, 3],
          [410, 3.5],
          [480, 4],
          [768, 3.7],
          [1200, 4.7],
          [1920, 5]
        ],
        "mouse-drag": true,
        "paginationPadding": _vm.isDesktop ? 3 : 2,
        "paginationSize": 6,
        "paginationPosition": 'bottom'
      }
    }, _vm._l((item.category), function(bannerImage, catogeryIndex) {
      return _c('slide', {
        key: catogeryIndex
      }, [_c('div', {
        staticClass: "carousel-block mx-2"
      }, [_c('router-link', {
        staticClass: "d-inline-block w-100",
        attrs: {
          "to": bannerImage.url_key || '/'
        }
      }, [_c('div', {
        staticClass: "icon-wrapper"
      }, [(bannerImage.has_tag && bannerImage.tag_name) ? _c('span', {
        staticClass: "large-icon-tag",
        staticStyle: {
          "top": "0"
        },
        style: ({
          backgroundColor: bannerImage.custom_text_color || ''
        })
      }, [_vm._v(_vm._s(bannerImage.tag_name))]) : _vm._e(), _vm._v(" "), _c('img', {
        staticClass: "img-auto carousel-img",
        staticStyle: {
          "width": "100px"
        },
        attrs: {
          "data-src": bannerImage.menu_icon_image,
          "width": "351",
          "height": "351"
        },
        on: {
          "error": function($event) {
            _vm.retryImageLoad($event, bannerImage.menu_icon_image)
          }
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "carousel-text"
      }, [_c('span', [_vm._v(_vm._s(bannerImage.name))])])])], 1)])
    }))], 1) : _vm._e()]) : _c('div', {
      staticClass: "category-container mt-2"
    }, [((_vm.isDesktop && item.is_active_web) || (!_vm.isDesktop && item.is_active_mobile)) ? _c('div', {
      staticClass: "cat-list nav-item"
    }, [(!item.web_dropdown) ? _c('div', {
      staticClass: "cat-list-dropdown"
    }, [_c('router-link', {
      staticClass: "d-block w-100",
      attrs: {
        "to": item.url_key || '/'
      }
    }, [_c('span', {
      style: (item.udf_1 ? {
        color: item.udf_1 || ''
      } : {})
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.has_tag && item.tag_name) ? _c('small', {
      staticClass: "singal-tag-name mb-30",
      style: ({
        color: item.custom_text_color || ''
      })
    }, [_vm._v(_vm._s(item.tag_name))]) : _vm._e()])], 1) : _c('div', {
      staticClass: "cat-list-toggle cat-list-dropdown d-flex justify-content-between align-items-center",
      attrs: {
        "id": 'catListMenuLink1' + catListIndex,
        "data-bs-toggle": "collapse",
        "data-bs-target": '#collapseCategory' + catListIndex,
        "role": "button",
        "aria-expanded": "false",
        "aria-controls": 'collapseCategory' + catListIndex
      },
      on: {
        "click": function($event) {
          item.is_dropdown_open = !item.is_dropdown_open
        }
      }
    }, [_c('span', {
      staticClass: "heading-wraper",
      style: (item.udf_1 ? {
        color: item.udf_1 || ''
      } : {})
    }, [(item.has_tag && item.tag_name) ? _c('small', {
      staticClass: "tag-name mb-30",
      style: ({
        color: item.custom_text_color || ''
      })
    }, [_vm._v(_vm._s(item.tag_name))]) : _vm._e(), _vm._v("\n                " + _vm._s(item.name))]), _vm._v(" "), _c('img', {
      staticClass: "arrowImg ms-2",
      class: item.is_dropdown_open ? 'arrow-up' : '',
      attrs: {
        "src": require("./assets/images/right-arrow.svg"),
        "alt": "Arrow"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse category-list",
      class: {
        show: item.is_dropdown_open
      },
      attrs: {
        "id": 'collapseCategory' + catListIndex
      }
    }, [(item.category && item.category.length && item.category.length > 0) ? _c('div', {
      staticClass: "category-conatiner"
    }, _vm._l((item.category), function(cat, catIndex) {
      return _c('div', {
        key: catIndex,
        staticClass: "catogery-list",
        class: _vm.isDesktop ? 'ml-2' : ''
      }, [_c('div', {
        staticClass: "padding-py3",
        class: catIndex < item.category.length - 1 ? 'category-dropdown' : ''
      }, [(!cat.web_dropdown) ? _c('div', {
        staticClass: "cat-dropdown"
      }, [_c('router-link', {
        staticClass: "d-block text-decoration-none hover-tag-name",
        attrs: {
          "to": cat.url_key || '/'
        }
      }, [_c('span', {
        staticClass: "heading-wraper",
        staticStyle: {
          "width": "100%"
        },
        style: (Object.assign({}, (cat.udf_1 ? {
            color: cat.udf_1
          } : {}),
          (cat.udf_2 ? {
            fontWeight: cat.udf_2
          } : {})))
      }, [(cat.has_tag && cat.tag_name) ? _c('small', {
        staticClass: "tag-name mb-30",
        style: ({
          color: cat.custom_text_color || ''
        })
      }, [_vm._v(_vm._s(item.tag_name))]) : _vm._e(), _vm._v("\n                            " + _vm._s(cat.name) + "\n                          ")])])], 1) : _c('div', {
        staticClass: "cat-toggle cat-dropdown d-flex justify-content-between align-items-center",
        attrs: {
          "data-bs-toggle": "collapse",
          "data-bs-target": '#collapseCategoryList' + catIndex,
          "role": "button",
          "aria-expanded": cat.is_dropdown_open ? 'true' : 'false',
          "aria-controls": 'collapseCategoryList' + catIndex
        },
        on: {
          "click": function($event) {
            cat.is_dropdown_open = !cat.is_dropdown_open
          }
        }
      }, [_c('span', {
        staticClass: "heading-wraper",
        style: (Object.assign({}, (cat.udf_1 ? {
            color: cat.udf_1
          } : {}),
          (cat.udf_2 ? {
            fontWeight: cat.udf_2
          } : {})))
      }, [(cat.has_tag && cat.tag_name) ? _c('small', {
        staticClass: "tag-name mb-30",
        style: ({
          color: cat.custom_text_color || ''
        })
      }, [_vm._v(_vm._s(cat.tag_name))]) : _vm._e(), _vm._v("\n                        " + _vm._s(cat.name) + "\n                      ")]), _vm._v(" "), _c('img', {
        staticClass: "arrowImg img-fade ms-2 mr-2",
        class: cat.is_dropdown_open ? 'arrow-up' : '',
        attrs: {
          "src": require("./assets/images/right-arrow.svg"),
          "alt": "Arrow"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "collapse category-list",
        class: {
          show: cat.is_dropdown_open
        },
        attrs: {
          "id": 'collapseCategoryList' + catListIndex
        }
      }, [_c('div', {
        staticClass: "sub-category-conatiner mt-2"
      }, [_c('div', {
        staticClass: "sub-category-list",
        class: {
          'has-small-icon': cat.sub_category.some(function (subCat) { return !subCat.is_large_icon; })
        }
      }, _vm._l((cat.sub_category), function(subCat, subCatIndex) {
        return _c('div', {
          key: subCatIndex,
          staticClass: "cat-icon-continer"
        }, [_c('router-link', {
          staticClass: "sub-cat-icon",
          class: subCat.is_large_icon ? 'sub-cat-large-icon' : '',
          attrs: {
            "to": subCat.url_key || '/'
          }
        }, [_c('div', {
          staticClass: "icon-wrapper"
        }, [(subCat.has_tag && subCat.tag_name) ? _c('span', {
          staticClass: "large-icon-tag",
          class: subCat.is_large_icon ? '' : 'small-icon-tag',
          style: ({
            backgroundColor: subCat.custom_text_color || ''
          })
        }, [_vm._v(_vm._s(subCat.tag_name))]) : _vm._e(), _vm._v(" "), (subCat.menu_icon_image) ? _c('img', {
          attrs: {
            "data-src": subCat.menu_icon_image,
            "alt": "icon"
          },
          on: {
            "error": function($event) {
              _vm.retryImageLoad($event, subCat.menu_icon_image)
            }
          }
        }) : _c('img', {
          attrs: {
            "src": require("./assets/./images/pdpmobile.png"),
            "alt": "icon"
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "sub-cat-name",
          class: subCat.is_large_icon ? '' : 'sub-cat-name-w'
        }, [_c('span', [_vm._v(_vm._s(subCat.name))])])])], 1)
      }))])])])])
    })) : _vm._e()])]) : _vm._e()])])
  })) : _vm._e(), _vm._v(" "), _vm._l((_vm.sideNavCommonData), function(item, commonCatListIndex) {
    return (_vm.sideNavCommonData && _vm.sideNavCommonData.length && _vm.sideNavCommonData.length > 0) ? _c('div', {
      key: commonCatListIndex,
      staticClass: "item-list category-dropdown pb-2"
    }, [_c('div', {
      staticClass: "category-container mt-2"
    }, [((_vm.isDesktop && item.is_active_web) || (!_vm.isDesktop && item.is_active_mobile)) ? _c('div', {
      staticClass: "cat-list nav-item"
    }, [(!item.web_dropdown) ? _c('div', {
      staticClass: "cat-list-dropdown"
    }, [_c('router-link', {
      staticClass: "d-block w-100",
      attrs: {
        "to": item.url_key || '/'
      }
    }, [_c('span', {
      style: (item.udf_1 ? {
        color: item.udf_1 || ''
      } : {})
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.has_tag && item.tag_name) ? _c('small', {
      staticClass: "singal-tag-name mb-30",
      style: ({
        color: item.custom_text_color || ''
      })
    }, [_vm._v(_vm._s(item.tag_name))]) : _vm._e()])], 1) : _c('div', {
      staticClass: "cat-list-toggle cat-list-dropdown d-flex justify-content-between align-items-center",
      attrs: {
        "id": 'catListMenuLink1' + commonCatListIndex,
        "data-bs-toggle": "collapse",
        "data-bs-target": '#collapseCategory' + commonCatListIndex,
        "role": "button",
        "aria-expanded": "false",
        "aria-controls": 'collapseCategory' + commonCatListIndex
      },
      on: {
        "click": function($event) {
          item.is_dropdown_open = !item.is_dropdown_open
        }
      }
    }, [_c('span', {
      staticClass: "heading-wraper",
      style: (item.udf_1 ? {
        color: item.udf_1 || ''
      } : {})
    }, [(item.has_tag && item.tag_name) ? _c('small', {
      staticClass: "tag-name mb-30",
      style: ({
        color: item.custom_text_color || ''
      })
    }, [_vm._v(_vm._s(item.tag_name))]) : _vm._e(), _vm._v("\n                " + _vm._s(item.name))]), _vm._v(" "), _c('img', {
      staticClass: "arrowImg ms-2",
      class: item.is_dropdown_open ? 'arrow-up' : '',
      attrs: {
        "src": require("./assets/images/right-arrow.svg"),
        "alt": "Arrow"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "collapse category-list",
      class: {
        show: item.is_dropdown_open
      },
      attrs: {
        "id": 'collapseCategory' + commonCatListIndex
      }
    }, [(item.category && item.category.length && item.category.length > 0) ? _c('div', {
      staticClass: "category-conatiner"
    }, _vm._l((item.category), function(cat, catIndex) {
      return _c('div', {
        key: catIndex,
        staticClass: "catogery-list",
        class: _vm.isDesktop ? 'ml-2' : ''
      }, [_c('div', {
        staticClass: "padding-py3",
        class: catIndex < item.category.length - 1 ? 'category-dropdown' : ''
      }, [(!cat.web_dropdown) ? _c('div', {
        staticClass: "cat-dropdown"
      }, [_c('router-link', {
        staticClass: "d-block text-decoration-none hover-tag-name",
        attrs: {
          "to": cat.url_key || '/'
        }
      }, [_c('span', {
        staticClass: "heading-wraper",
        style: (Object.assign({}, (cat.udf_1 ? {
            color: cat.udf_1
          } : {}),
          (cat.udf_2 ? {
            fontWeight: cat.udf_2
          } : {})))
      }, [(cat.has_tag && cat.tag_name) ? _c('small', {
        staticClass: "tag-name mb-30",
        style: ({
          color: cat.custom_text_color || ''
        })
      }, [_vm._v(_vm._s(item.tag_name))]) : _vm._e(), _vm._v("\n                        " + _vm._s(cat.name) + "\n                      ")])])], 1) : _c('div', {
        staticClass: "cat-toggle cat-dropdown d-flex justify-content-between align-items-center",
        attrs: {
          "data-bs-toggle": "collapse",
          "data-bs-target": '#collapseCategoryList' + catIndex,
          "role": "button",
          "aria-expanded": cat.is_dropdown_open ? 'true' : 'false',
          "aria-controls": 'collapseCategoryList' + catIndex
        },
        on: {
          "click": function($event) {
            cat.is_dropdown_open = !cat.is_dropdown_open
          }
        }
      }, [_c('span', {
        staticClass: "heading-wraper",
        style: (Object.assign({}, (cat.udf_1 ? {
            color: cat.udf_1
          } : {}),
          (cat.udf_2 ? {
            fontWeight: cat.udf_2
          } : {})))
      }, [(cat.has_tag && cat.tag_name) ? _c('small', {
        staticClass: "tag-name mb-30",
        style: ({
          color: cat.custom_text_color || ''
        })
      }, [_vm._v(_vm._s(item.tag_name))]) : _vm._e(), _vm._v("\n                        " + _vm._s(cat.name) + "\n                      ")]), _vm._v(" "), _c('img', {
        staticClass: "arrowImg img-fade ms-2 mr-2",
        class: cat.is_dropdown_open ? 'arrow-up' : '',
        attrs: {
          "src": require("./assets/images/right-arrow.svg"),
          "alt": "Arrow"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "collapse category-list",
        class: {
          show: cat.is_dropdown_open
        },
        attrs: {
          "id": 'collapseCategoryList' + commonCatListIndex
        }
      }, [_c('div', {
        staticClass: "sub-category-conatiner mt-2"
      }, [_c('div', {
        staticClass: "sub-category-list",
        class: {
          'has-small-icon': cat.sub_category.some(function (subCat) { return !subCat.is_large_icon; })
        }
      }, _vm._l((cat.sub_category), function(subCat, subCatIndex) {
        return _c('div', {
          key: subCatIndex,
          staticClass: "cat-icon-continer"
        }, [_c('router-link', {
          staticClass: "sub-cat-icon",
          class: subCat.is_large_icon ? 'sub-cat-large-icon' : '',
          attrs: {
            "to": subCat.url_key || '/'
          }
        }, [_c('div', {
          staticClass: "icon-wrapper"
        }, [(subCat.has_tag && subCat.tag_name) ? _c('span', {
          staticClass: "large-icon-tag",
          class: subCat.is_large_icon ? '' : 'small-icon-tag',
          style: ({
            backgroundColor: subCat.custom_text_color || ''
          })
        }, [_vm._v(_vm._s(subCat.tag_name))]) : _vm._e(), _vm._v(" "), (subCat.menu_icon_image) ? _c('img', {
          attrs: {
            "data-src": subCat.menu_icon_image,
            "alt": "icon"
          }
        }) : _c('img', {
          attrs: {
            "src": require("./assets/./images/pdpmobile.png"),
            "alt": "icon"
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "sub-cat-name",
          class: subCat.is_large_icon ? '' : 'sub-cat-name-w'
        }, [_c('span', [_vm._v(_vm._s(subCat.name))])])])], 1)
      }))])])])])
    })) : _vm._e()])]) : _vm._e()])]) : _vm._e()
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58bdad2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/sideNav.vue
// module id = 922
// module chunks = 117